import { PackageType, PackageConfig, OrderValues } from '@ca/common/types'
import { getRemoteConfig } from 'hooks/useRemoteConfigStore'
import checkOrderValues from './utils/checkOrderValues'

export const checkPackageCondition = (
  pckg: PackageConfig,
  values: OrderValues
) => {
  if (!pckg.condition) {
    return true
  }
  const config = getRemoteConfig()
  if (!config) {
    return false
  }
  const condition = config.conditions[pckg.condition]
  return checkOrderValues(condition, values, config)
}

export const isPackageAvailable = (
  pckg: PackageConfig,
  base: PackageConfig | null | undefined,
  values: OrderValues,
  upgradeTypes: PackageType[] = ['office']
) => {
  if (upgradeTypes.includes(pckg.type)) {
    return true
  }
  if (!checkPackageCondition(pckg, values)) {
    return false
  }

  if (!base) {
    return true
  }
  return pckg.type === base.type
}
